import { api } from './api';
import { redirect } from 'react-router-dom';

export function isAuthenticated() {
  return Boolean(localStorage.getItem('tiendaya_token'));
}

// Obtener información del usuario desde localStorage
function getUserInfo() {
  try {
    const userInfo = localStorage.getItem('tiendaya_user');
    return userInfo ? JSON.parse(userInfo) : null;
  } catch (error) {
    console.error('Error parsing user info:', error);
    return null;
  }
}

// Verificar si el usuario es merchant (dueño de tienda)
export function isMerchant() {
  const token = localStorage.getItem('tiendaya_token');
  if (!token) return false;
  
  const userInfo = getUserInfo();
  return userInfo?.is_merchant === true;
}

// Verificar si el usuario es superadmin
export function isSuperAdmin() {
  const token = localStorage.getItem('tiendaya_token');
  if (!token) return false;
  
  const userInfo = getUserInfo();
  return userInfo?.is_superuser === true;
}

// Verificar si el usuario es cliente (no merchant ni superadmin)
export function isCustomer() {
  const token = localStorage.getItem('tiendaya_token');
  if (!token) return false;
  
  const userInfo = getUserInfo();
  return userInfo?.user_type === 'customer' && !userInfo?.is_merchant && !userInfo?.is_superuser;
}

export function requireAuth(loader) {
  return async () => {
    if (!isAuthenticated()) {
      throw new Response('Unauthorized', {
        status: 401,
        statusText: 'Debe iniciar sesión para continuar',
      });
    }
    return loader ? loader() : null;
  };
}

export async function checkSubscriptionStatus() {
  try {
    const { data } = await api.get('/api/subscription/status/');
    return {
      isTrialActive: data.is_trial_active,
      subscriptionStatus: data.subscription_status,
      hasPendingPayment: data.has_pending_payment || false,
      isSuspended: !data.is_trial_active || data.subscription_status === 'SUSPENDED' || data.subscription_status === 'CANCELLED' || data.has_pending_payment
    };
  } catch (error) {
    console.error('Error checking subscription status:', error);
    // En caso de error, asumimos que está suspendido para ser seguro
    return { isTrialActive: false, subscriptionStatus: 'UNKNOWN', hasPendingPayment: false, isSuspended: true };
  }
}

export function requireAuthAndActiveSubscription(loader) {
  return async () => {
    if (!isAuthenticated()) {
      throw new Response('Unauthorized', {
        status: 401,
        statusText: 'Debe iniciar sesión para continuar',
      });
    }

    // Siempre permitir acceso pero marcar el estado de suscripción
    const subscriptionStatus = await checkSubscriptionStatus();

    // Pasar el estado de suscripción al loader para que el componente pueda manejarlo
    return loader ? loader(subscriptionStatus) : subscriptionStatus;
  };
}
